import React from 'react';
import { useIntl } from 'react-intl';
import { Button, makeStyles } from '@popmenu/common-ui';
import type { MenuItemRestaurantLinkKind } from '~/libs/gql/types';
import { useRestaurantLinkText } from '~/eat/hooks/useRestaurantLinkText';

const useStyles = makeStyles({
  button: {
    alignSelf: 'flex-start',
    borderRadius: 22,
    fontWeight: 600,
    minHeight: 44,
    textTransform: 'none',
  },
});

type RestaurantLinkButtonProps = {
  dishName: string
  link: {
    kind: MenuItemRestaurantLinkKind
    url: string
  }
  restaurantName: string
}

// A dish's link out to the restaurant's site, opening in a new tab
export const RestaurantLinkButton = ({ dishName, link, restaurantName }: RestaurantLinkButtonProps) => {
  const classes = useStyles();
  const intl = useIntl();
  const restaurantLinkText = useRestaurantLinkText();
  const cta = restaurantLinkText(link.kind, restaurantName);

  return (
    <Button
      aria-label={intl.formatMessage({ defaultMessage: '{cta}: {dishName} at {restaurantName} (opens in a new tab)' }, { cta, dishName, restaurantName })}
      className={classes.button}
      component="a"
      href={link.url}
      rel="noopener"
      role="link"
      target="_blank"
      variant="outlined"
    >
      {cta}
    </Button>
  );
};
